import React from 'react';
import PropTypes from 'prop-types';

import Translate from '@hydra/common/components/i18n';
import Criterium from '@hydra/common/criterium/Criterium';
import SafeAnchor from '@hydra/common/components/SafeAnchor';
import CriteriumIconAndText from '@hydra/common/criterium/CriteriumIconAndText';

export const CanonicalTags = ({ criterium }) => {
  const { data } = criterium;
  const { canonicals, errors } = data;
  let content;
  if (canonicals.length === 0) {
    content = <Translate content='canonical_tags_not_found' />;
    return <Criterium criterium={criterium}>{content}</Criterium>;
  }

  if (errors.length === 0) {
    const { href, source } = canonicals[0];
    const definedInHtml = canonicals.find(canonical => canonical.href === href && canonical.source === 'HTML');
    const definedInHeader = canonicals.find(canonical => canonical.href === href && canonical.source === 'HEADER');
    const isDefinedInBoth = definedInHtml && definedInHeader;
    content = (
      <>
        <Translate component='div' content='canonical_tag_found' />
        <SafeAnchor href={href} rel='nofollow noopener noreferrer' target='_blank'>{href}</SafeAnchor>
        {!isDefinedInBoth && <> - <Translate content={`canonical_tag_defined_in_${source.toLowerCase()}`} /></>}
        {isDefinedInBoth && <Translate component='div' content='canonical_tag_defined_html_and_headrs' />}
      </>
    );

    return <Criterium criterium={criterium}>{content}</Criterium>;
  }

  const mismatchError = errors.find(({ type }) => type === 'MULTIPLE_CANONICALS_MISMATCH');
  if (mismatchError) {
    content = (
      <>
        <Translate component='div' content='canonical_tags_multiple_mismatch' />
        {
          canonicals.map(({ href, source }, i) => (
            <div key={i}>
              <SafeAnchor
                href={href}
                rel='nofollow noopener noreferrer'
                target='_blank'
              >
                {href}
              </SafeAnchor> - <Translate content={`canonical_tag_defined_in_${source.toLowerCase()}`} />
            </div>
          ))
        }
      </>
    );
  } else {
    const { source, href: canonicalDom } = canonicals[0];
    content = (
      <>
        <Translate component='div' content={`canonical_tag_with_errors_defined_in_${source.toLowerCase()}`} />
        {
          errors.map(({ href, type }, i) => (
            <CriteriumIconAndText
              key={i}
              success={false}
              text={<Translate content={type.toLowerCase()} with={{ url: href, canonicalDom }} />}
            />
          ))
        }
      </>
    );
  }

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

CanonicalTags.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      canonicals: PropTypes.array,
      errors: PropTypes.array
    })
  })
};

export default React.memo(CanonicalTags);
